/**
 * The "Parts" row-filter dropdown used across the call-off grids.
 *
 * @link partPrefixFilter for the options and the matching rule.
 */
import { PART_PREFIX_FILTER_OPTIONS, type PartPrefixFilter } from './partPrefixFilter';

interface PartPrefixSelectProps {
  value: PartPrefixFilter;
  onChange: (value: PartPrefixFilter) => void;
  /** Sizing and styling classes — each grid keeps its own control height. */
  className: string;
}

export default function PartPrefixSelect({ value, onChange, className }: PartPrefixSelectProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as PartPrefixFilter)}
      className={className}
      aria-label="Row filter"
    >
      {PART_PREFIX_FILTER_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
}
